import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UpvMark, DoItSignature } from "@/components/brand/Brand";
import { KpiRow, OccupancyChart, FlowCards, CompanyInteraction, LiveFeed, AcademicCharts } from "@/components/dashboard/DashboardParts";
import { api } from "@/lib/api";
import { UserChip } from "@/components/auth/UserChip";
import { FullLoader } from "@/components/auth/RequireRole";

import { useI18n } from "@/lib/i18n/i18n";
import { LangSwitcher } from "@/components/i18n/LangSwitcher";

const VIEWS = [
  { id: "live", label: "EN DIRECTO" },
  { id: "day1", label: "DÍA 1" },
  { id: "day2", label: "DÍA 2" },
  { id: "total", label: "TOTAL EVENTO" },
];

export default function DashboardUPV() {

  const [view, setView] = useState("live");
  const { t } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/dashboard", { params: { view } }).then((r) => alive && setData(r.data)).catch(() => {});
    load();
    const id = setInterval(load, view === "live" ? 8000 : 30000);
    return () => { alive = false; clearInterval(id); };
  }, [view]);
  if (!data) return <FullLoader />;

  return (
    <div className="min-h-screen bg-[#F6F6F4]" data-testid="dashboard-page">
      <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 lg:px-10">
          <UpvMark />
          <div className="flex items-center gap-4"><LangSwitcher testPrefix="dashboard-lang" /><Link to="/backoffice" className="hidden text-xs font-semibold text-slate-600 hover:text-upv sm:inline" data-testid="dashboard-backoffice-link">Backoffice</Link><DoItSignature className="hidden lg:block" /><UserChip /></div>
        </div>
      </header>
      <main className="mx-auto max-w-[1440px] space-y-6 px-5 py-10 lg:px-10">
        <div className="flex flex-col gap-6 pb-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-upv">{t("Foro de Empleo UPV 2027")}</p>
            <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid="dashboard-title">{t("Panel de control")}</h1>
          </div>
          <div className="flex w-full flex-wrap gap-1 rounded-2xl border border-slate-200 bg-white p-1.5 sm:w-fit" data-testid="dashboard-view-selector">
            {VIEWS.map((v) => (
              <button key={v.id} onClick={() => setView(v.id)} className={`flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-xs font-bold tracking-wider transition-colors sm:flex-none ${view === v.id ? "bg-slate-950 text-white" : "text-slate-500 hover:bg-slate-100"}`} data-testid={`dashboard-view-${v.id}`}>
                {v.id === "live" && <span className="h-2 w-2 animate-pulse rounded-full bg-rose-500" />}{t(v.label)}
              </button>
            ))}
          </div>
        </div>
        <KpiRow data={data} />
        <section className="grid gap-6 lg:grid-cols-12"><OccupancyChart data={data} /><FlowCards data={data} /></section>
        <section className="grid gap-6 lg:grid-cols-12">
          <CompanyInteraction data={data} />
          <LiveFeed feed={data.feed} />
        </section>
        <AcademicCharts data={data} />
      </main>
    </div>
  );
}
